// Shared formatting helpers for the "On Site" sign-in/sign-out feature —
// used by both the aggregate OnSitePage and the per-project embedded panel.
export function fmtDT(iso) {
    if (!iso) return "—";
    try { return new Date(iso).toLocaleString("en-GB", { day: "2-digit", month: "short", hour: "2-digit", minute: "2-digit" }); }
    catch { return iso; }
}
export function isToday(iso) {
    try { return new Date(iso).toDateString() === new Date().toDateString(); } catch { return true; }
}
export function daysSince(iso) {
    try { return Math.floor((Date.now() - new Date(iso).getTime()) / 86400000); } catch { return 0; }
}
export function toLocalInput(iso) {
    try {
        const d = iso ? new Date(iso) : new Date();
        const off = d.getTimezoneOffset();
        return new Date(d.getTime() - off * 60000).toISOString().slice(0, 16);
    } catch { return ""; }
}
// "Subcontractor" displays as "Sub-contractor" everywhere a person signs in /
// is inducted — the stored value is never changed, display only.
export function personTypeLabel(pt) {
    return pt === "Subcontractor" ? "Sub-contractor" : (pt || "");
}
export function personTypeDisplay(pt, other) {
    if (pt === "Other" && other) return `Other - ${other}`;
    return personTypeLabel(pt);
}
